<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: "",
  },
  bodyTitle: {
    type: String,
    default: "",
  },
  bodySubtitle: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <div>
    <LoaderSpinner size="3xl" class="mt-8" />
    <div class="mt-4 flex flex-col items-center gap-1">
      <p class="text-neutral-200 font-bold">
        {{ bodyTitle || $t("main.modalLoader.transactionInProgress") }}
      </p>
      <p class="text-neutral-300 text-center max-w-sm">
        {{ bodySubtitle || $t("main.modalLoader.transactionUnderway") }}
      </p>
    </div>
    <div class="mt-5 mb-2 sm:mt-6 flex"></div>
  </div>
</template>
